import { combinedGeoJson } from '../firestore/combined.js'
import { connectionTypeFilter, freePaidFilter, chargerSpeedFilter } from './combinedHelper.js'

export default {
  state: {
    isLoaded: false,
    data: {},
    fastLimit: 40,
    mediumLimit: 20
  },
  getters: {
    data (state) {
      if (state.isLoaded) {
        return state.data
      } else {
        return {}
      }
    },
    filteredData (state, getters, rootState) {
      let features = []
      if (state.isLoaded) {
        const connectionTypeOptions = rootState.map.filter.connectionType
        const freePaidOptions = rootState.map.filter.freePaid
        const chargerSpeedOptions = rootState.map.filter.chargerSpeed
        const fastLimit = state.fastLimit
        const mediumLimit = state.mediumLimit
        features = state.data.features
          .filter((feature) => {
            let count = 0
            feature.properties.stations.forEach((station) => {
              if (connectionTypeFilter(station, connectionTypeOptions) &&
                freePaidFilter(station, freePaidOptions) &&
                chargerSpeedFilter(station, chargerSpeedOptions, feature, fastLimit, mediumLimit)
              ) {
                count += 1
              }
            })
            return count > 0
          })
      }
      return {
        features: features,
        type: 'FeatureCollection'
      }
    }
  },
  mutations: {
    loadSuccess (state) {
      state.isLoaded = true
      console.log('Mutation: combined/loadSuccess')
    },
    storeData (state, payload) {
      state.data = payload
      console.log('Mutation: combined/storeData')
    }
  },
  actions: {
    getData (context) {
      return new Promise(function (resolve, reject) {
        combinedGeoJson()
          .then((combinedGeoJson) => {
            context.commit('loadSuccess')
            context.commit('storeData', combinedGeoJson)
            context.dispatch('chargerList/buildList', null, { root: true })
          })
          .then(() => {
            resolve('data loaded')
          })
      })
    }
  },
  namespaced: true
}
